import firebaseMessaging from '@/firebase-messaging'

export default {
    install(Vue) {
        Vue.prototype.$fire = {
            messaging: firebaseMessaging
        }
    }
}
